import React from "react";
import axios from "axios";

export const countryApi = async (id) => {
  try {
    let url = `https://visapro.herokuapp.com/api/v1/countries/name/${id}`;

    const response = await axios.get(url);
    const country = {
      data: response.data,
    };
    return country;
  } catch (error) {
    const country = {
      error: error,
    };
    return country;
  }
};
